import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, BookOpen, Guitar, Music, Timer, Mic, ShoppingBag } from 'lucide-react';

export interface TabBarProps {
  className?: string;
}

export const TabBar: React.FC<TabBarProps> = ({ className = '' }) => {
  const tabs = [
    { to: '/dashboard', label: 'خانه', icon: Home, testId: 'nav-link-dashboard' },
    { to: '/tabs', label: 'کتابخانه', icon: BookOpen, testId: 'nav-link-library' },
    { to: '/chords', label: 'آکوردها', icon: Guitar, testId: 'nav-link-chords' },
    { to: '/scales', label: 'گام‌ها', icon: Music, testId: 'nav-link-scales' },
    { to: '/routines', label: 'روتین‌ها', icon: Timer, testId: 'nav-link-routines' },
    { to: '/tuner', label: 'تیونر', icon: Mic, testId: 'nav-link-tuner' },
    { to: '/marketplace', label: 'بازارچه', icon: ShoppingBag, testId: 'nav-link-marketplace' }
  ];

  return (
    <nav
      data-testid="mobile-tabbar"
      aria-label="ناوبری اصلی"
      className={`lg:hidden fixed bottom-0 inset-x-0 h-[84px] pb-[env(safe-area-inset-bottom,20px)] bg-base-200/95 backdrop-blur border-t border-base-300 z-40 select-none ${className}`}
    >
      <div className="grid grid-cols-7 h-[64px] items-center px-1">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          return (
            <NavLink
              key={tab.to}
              to={tab.to}
              data-testid={tab.testId}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-1 transition min-h-12 ${
                  isActive ? 'text-primary-soft' : 'text-base-content/60 hover:text-base-content'
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <div
                    className={`flex items-center justify-center w-11 max-[359px]:w-9 h-7 rounded-full transition ${
                      isActive ? 'bg-primary/[0.18] text-primary-soft' : 'bg-transparent'
                    }`}
                  >
                    <Icon className="size-5" />
                  </div>
                  <span className="text-[10px] max-[359px]:text-[9px] whitespace-nowrap font-semibold leading-none tracking-tight">
                    {tab.label}
                  </span>
                </>
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};

TabBar.displayName = 'TabBar';
